import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
  Wrapper: {
    height: 'auto',
    width: '100%',
    position: 'relative',
    '& .MuiTypography-h6': {
      fontSize: '17px',
    },
  },
  Header: {
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    height: '70px',
    gap: '20px',
    '& p': { fontSize: 'larger' },
    '& span': { color: 'orange', fontSize: '20px' },
  },
  ToMain: {
    fontSize: '20px',
    cursor: 'pointer',
  },
  FilterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    padding: '0 10px',
  },
  SummarySection: {
    margin: '0 10px 16px',
    padding: '10px',
    border: '1px solid #fc7f03',
    borderRadius: '8px',
  },
  SummaryStats: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  SummarySubBlock: {
    marginTop: '16px',
    padding: '12px 16px',
    border: '1px dashed #fc7f03',
    borderRadius: '8px',
  },
  SummarySubTitle: {
    marginBottom: '8px !important',
    fontWeight: 600,
  },
  StatCard: {
    padding: '8px',
    borderRadius: '8px',
    backgroundColor: '#ede9e4',
    textAlign: 'center' as const,
  },
  SectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 10px 0',
  },
  GridStyles: {
    backgroundColor: '#ede9e4',
    borderRadius: '0px',
    border: 'none',
    marginBottom: '24px',
    '& .MuiDataGrid-virtualScroller': { marginTop: '0 !important' },
    '& .MuiDataGrid-main': { overflow: 'visible' },
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: 'warning.main',
      position: 'sticky',
      zIndex: 2,
      borderRadius: '0px',
      border: '0px',
    },
    '.MuiDataGrid-columnHeaderTitleContainer': {
      color: '#fff',
      fontSize: '15px',
      padding: '10px',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
    },
    '.MuiDataGrid-cell': {
      border: '1px solid #fc7f03',
      padding: '5px',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
    },
    '.MuiDataGrid-footerContainer': { border: '1px solid #fc7f03' },
    '.MuiDataGrid-footerContainer p': { margin: '0px' },
    '.MuiDataGrid-columnHeaderTitle': { overflow: 'visible', lineHeight: '1.43rem', whiteSpace: 'normal' },
  },
}));
